export default __webpack_public_path__ + "static/media/white.fb59e4b2.png";